export default __webpack_public_path__ + "static/media/โปรที่2BT86.92d13508.png";